import React from "react";
import clsx from "clsx";

import styles from "./layout.module.scss";

type LineDividerProps = {
	className?: string;
	type?: "tight";
	margin?: "sm" | "lg";
};

export const LineDivider = ({ className, type, margin }: LineDividerProps) => {
	const typeClassName = type && styles[type];
	const marginClassName = margin && styles[margin];
	return (
		<hr
			className={clsx(
				styles.lineDivider,
				className,
				typeClassName,
				marginClassName,
			)}
		/>
	);
};
